import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { MyWorkPage } from "../components/my-work/MyWorkPage";
import { myWorkSearchSchema } from "../components/my-work/my-work-search";

/** My work's Assigned to me (BUILD_SPEC §12.7), its peek's issue and its grouping in the address. */
function Page() {
  const search = useSearch({ from: "/admin/my/" });
  const navigate = useNavigate({ from: "/admin/my/" });
  return (
    <MyWorkPage
      view="assigned"
      search={search}
      onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })}
    />
  );
}

export const Route = createFileRoute("/admin/my/")({ validateSearch: myWorkSearchSchema, component: Page });
